<template>
    <div id='ReceiptList' class='row'>
        <div class='col-12'>
            <div class='row'>
                <div class='col-12 ListOfReceipts'>
                    <List
                        :initialReportState='report'
                        :allowExport='true'
                        listType='Receipt'
                        @manage-box='manageBox'
                        @delete='deleteItem'
                    >
                        <template v-slot:buttons>
                            <Button 
                                btnAction='link'
                                btnTarget='/buy-tracker/receipt-create'
                                CTA='Create New Reciept'
                                type='primary'
                                btnClass='BtnCreate'
                            />
                        </template>
                    </List>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TextBox from '../../../core/form/TextBox.vue';
    import Button from '../../../core/form/Button.vue';
    import DisplayIcon from '../../../icons/DisplayIcon';
    import List from '../../../core/list/List';
    export default{
        name: 'ReceiptList',
        components: {
            TextBox,
            Button,
            DisplayIcon,
            List
        },
        computed: {
            report() {
                var report = this.$store.getters['BuyTracker/ReceiptCreate/receiptReportList'];
                return report ? report : this.$store.getters['BuyTracker/ReceiptCreate/receiptReportList'];
            }
        },
        methods:{
            addtoBox(value){
                console.log('Adding to Box - '+ value); //TODO - Add To Box
            },
            manageBox(){
                console.log('manageBox reached!!')
            },
            deleteItem(){
                console.log('deleteItem reached!!')
            },
            exportItems(){
                console.log('export items'); //TODO: Export items
            }
        }
    }
</script>